export const Common = {
    "系统提示":"系统提示",
    "提示":"提示",
    "暂无内容":"暂无内容",
    "暂无数据":"暂无数据～",
    "暂无动态":"暂无动态",
    "暂无疑问":"暂无疑问",
    "确定":"确定",
    "取消":"取消",
    "编辑":"编辑",
    "删除":"删除",
    "归档":"归档",
    "复制":"复制",
    "转让":"转让",
    "退课":"退课",
    "置顶":"置顶",
    "取消置顶":"取消置顶",
    "启用加课码":"启用加课码",
    "重置加课码":"重置加课码",
    "停用加课码":"停用加课码",
    "排序":"排序",
    "完成":"完成",
    "添加活动":"添加活动",
    "重命名":"重命名",
    "恢复":"恢复",
    "加载中":"加载中...",
    "图片加载中":"图片加载中...",
    "加载失败":"加载失败",
    "添加":"添加",
    "保存":"保存",
    "删除提示":"删除提示",
    "删除成功":"删除成功!",
    "暂无":"暂无",
    "没有更多了":"没有更多了",
    "添加到章节":"添加到章节",
    '线上':'线上',
    '线下':'线下',
    '混合':'混合',
    "学":"学",
    "教":"教",
    "协":"协",
    "请输入名称":"请输入名称",
    "提交":"提交",
    "搜索":"搜索",
    "变更成功":"变更成功",
    "讨论":"讨论",
    "按时间顺序":"按时间顺序",
    "老师":"老师",
    "发布于":"发布于",
    "回复":"回复",
    "暂无评论":"暂无评论",
    "发送":"发送",
    "请输入":"请输入...",
    "发表评论":"发表评论...",
    CourseMenu:{
        "目录":"目录",
        "互动课件":"互动课件",
        "作业":"作业",
        "测试":"测试",
        "资料":"资料",
        "腾讯会议":"腾讯会议",
        "公告":"公告",
        "话题":"话题",
        "互动答题":"互动答题",
        "互动":"互动",
        "答题":"答题",
        "课件":"课件",
        "会议":"会议",
  },
  "选择章节":"选择章节",
  "定时器已存在":"定时器已存在！",
  "全部":"全部",
  "发布":"发布",
  "结束发布":"结束发布",
  "展开全部":"展开全部",
  "条回复":"条回复",
  "全部回复":"全部回复",
  "第":"第",
  "页":"页",
  "个人详情页":"个人详情页",
  "疑问":"疑问",
  "请输入学生姓名学号":"请输入学生姓名学号",
  "完成时间":"完成时间：",
  "分":"分",
  "完善成功":"完善成功",
  "选课":"选课",
  "人":"人",
  "加课":"加课",
  "到期":"",
  "截止":"截止",
  "开始时间":"开始时间：",
  "创建于":"创建于",
  "下一步":"下一步",
  "上一步":"上一步",
  "错误":"错误",
  "来自":"来自：",
  "赞":"赞",
  "分享":"分享",
  "编辑会议直播":"编辑会议直播",
  "编辑话题讨论":"编辑话题讨论",
  "编辑文章内容":"编辑文章内容",
  "编辑视频内容":"编辑视频内容",
  "仅老师可以申请加入教研室":"仅老师可以申请加入教研室",
  "请求失败点击重新加载":"请求失败，点击重新加载",
  "点击进行下载":"点击进行下载",
  "播放观看":"播放观看",
  "总页":"页",
  "阅读全文":"阅读全文",
  "点击查看":"点击查看",
  "申请加入虚拟教研室可以继续阅读和名师一起研讨引用优质教学资源":"申请加入虚拟教研室可以继续阅读，和名师一起研讨，引用优质教学资源",
  "当前文件格式不支持预览请下载到本地查看":"当前文件格式不支持预览，请下载到本地查看",
  "申明内容来自用户上传著作权归原作者所有如涉侵权问题请联系平台官方客服我们将及时处理":"申明：内容来自用户上传，著作权归原作者所有，如涉侵权问题，请联系平台官方客服，我们将及时处理",
  "申请加入":"申请加入",
  "参与评论":"参与评论！",
  "阅读":"阅读",
  "动态":"动态",
  "资源":"资源",
  "已加入":"已加入",
  "文科类":"文科类",
  "您已经加入不需要重复加入":"您已经加入，不需要重复加入",
  "加入虚拟教研室立即使用":"加入虚拟教研室，立即使用",
  "根据管理者的权限设置您没有权限下载该资源":"根据管理者的权限设置，您没有权限下载该资源",
  "请选择一个课程":"请选择一个课程",
  "该链接无法跳转":"该链接无法跳转",
  "点赞":"点赞",
  "评论":"评论",
  "已取消点赞":"已取消点赞",
  "点赞成功":"点赞成功",
  "查看链接":"查看链接",
  "直播回放 ":"直播回放",
  "浏览":"浏览",
  "创建人":"创建人：",
  "授课对象":"授课对象：",
  "试卷":"试卷",
  "来自样板课程":"来自样板课程：",
  "道试题":"道试题",
  "收起":"收起",
  "文章":"文章",
  "人次参与讨论":"人次参与讨论",
  "分享卡":"分享卡",
  "长按保存图片或发送给朋友":"长按保存图片或发送给朋友。",
  "链接复制失败":"链接复制失败",
  "链接复制成功":"链接复制成功",
  "已经全部加载完了没有更多了":"已经全部加载完了，没有更多了",
  "继续阅读":"继续阅读",
  "剩余":"剩余",
  "条动态未读":"条动态未读",
  "导入":"导入",
  "课件":"课件",
  "发布成功":"发布成功",
  "导入成功":"导入成功",
  "添加成功":"添加成功",
  "保存成功":"保存成功",
  "外链":"外链",
  "本地上传":"本地上传",
  "导入已有":"导入已有",
  "文件上传失败":"文件上传失败",
  "课前":"课前",
  "全部成员":"全部成员",
  "慕课视频":"慕课视频",
  "录播":"录播",
  "未发布":"未发布",
  "未开始":"未开始",
  "进行中":"进行中",
  "已结束":"已结束",
  "详情":"详情",
  "已选":"已选",
  "个课程":"个课程",
  "立即加入学习":"立即加入学习",
  "选修课程":"选修课程",
  "可批量选择课程并加入":"可批量选择课程并加入",
  "人已学习":"人已学习",
  "请至少选择一个课程":"请至少选择一个课程",
  "请先登录":"请先登录",
  "立即登录":"立即登录",
  "请先进行身份认证":"请先进行身份认证",
  "立即认证":"立即认证",
  "重命名文件":"重命名文件",
  "请输入文件名":"请输入文件名",
  "修改成功":"修改成功",
  "关闭":"关闭",
  "刷新成功":"刷新成功!",
  "反馈类型":"反馈类型",
  "您的邮箱":"您的邮箱",
  "请输入邮箱地址":"请输入邮箱地址",
  "问题描述":"问题描述",
  "这里输入您反馈的问题":"这里输入您反馈的问题…",
  "使用帮助":"使用帮助",
  "产品建议":"产品建议",
  "功能异常":"功能异常",
  "请确认邮箱":"请确认邮箱",
  "请输入反馈问题":"请输入反馈问题",
  "常见问题":"常见问题",
  "搜索您的问题或关键词":"搜索您的问题或关键词",
  "意见反馈":"意见反馈",
  "个搜索结果":"个搜索结果",
  "无符合条件的搜索结果":"无符合条件的搜索结果",
  "章节目录":"章节目录",
  "暂无简介":"暂无简介",
  "课程内容":"课程内容",
  "加入老师的课程后可查看详情并学习":"加入老师的课程后可查看详情并学习",
  "该课程已关闭":"该课程已关闭",
  "关注课堂派公众号发现更多精彩课程":"关注课堂派公众号，发现更多精彩课程",
  "立即加入":"立即加入",
  "立即学习":"立即学习",
  "华文慕课视频":"华文慕课视频",
  "华文慕课外链":"华文慕课外链",
  "进入直播":"进入直播",
  "直播未开启":"直播未开启",
  "发送弹幕评论":"发送弹幕/评论...",
  "直播技术由课堂派提供发送弹幕需要先登录课堂派是否立即登录":"直播技术由课堂派提供，发送弹幕需要先登录课堂派，是否立即登录？",
  "前往登录":"前往登录",
  "继续观看":"继续观看",
  "直播暂停或已结束":"直播暂停或已结束",
  "至少选择一个":"至少选择一个",
}